const strings = {
  OK: {
    SE: 'Ok',
    EN: 'Ok'
  }
}

export default strings



// WEBPACK FOOTER //
// ./src/components/containers/Alert/strings.js